module.exports = __webpack_public_path__ + "img/car-red-vertical.2fb568de.svg";